import { render, staticRenderFns } from "./zcfbqk.vue?vue&type=template&id=50178db0"
import script from "./zcfbqk.vue?vue&type=script&lang=js"
export * from "./zcfbqk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports